import { ActionReducer, combineReducers, createFeature } from '@ngrx/store';

import { surveyCreationCoreReducer } from './core/survey-creation-core.reducer';
import { surveyCreationAudienceReducer } from './audience/survey-creation-audience.reducer';
import { insightsReducer } from './insights/survey-creation-insights.reducer';
import { surveyCreationReferenceReducer } from './reference/survey-creation-reference.reducer';
import { surveyCreationLaunchReducer } from './launch/survey-creation-launch.reducer';
import { INITIAL_SURVEY_CREATION_STATE } from './survey-creation-state.constants';
import { SurveyCreationState } from './survey-creation-state.model';
import { withCoreContext } from '../utils/core-context/survey-creation-action-core-context.helper';
import { participantRecordKeys } from './survey-creation-child-registry.helper';

export const surveyCreationFeatureKey = 'surveyCreation';

const combinedReducer = combineReducers<SurveyCreationState>({
  core: surveyCreationCoreReducer,
  audience: surveyCreationAudienceReducer,
  insights: insightsReducer,
  reference: surveyCreationReferenceReducer,
  launch: surveyCreationLaunchReducer,
});

// Sibling slices can't read core, so core's context (incl. participant keys) rides on each action.
const surveyCreationReducer: ActionReducer<SurveyCreationState> = (
  state = INITIAL_SURVEY_CREATION_STATE,
  action,
) =>
  combinedReducer(
    state,
    withCoreContext(action, {
      ...state.core,
      participantKeys: [...participantRecordKeys(state.core.children)],
    }),
  );

export const surveyCreationFeature = createFeature({
  name: surveyCreationFeatureKey,
  reducer: surveyCreationReducer,
});
